module.exports = __webpack_public_path__ + "static/img/gouza.436d3c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/gouza.png
// module id = 450
// module chunks = 1